import React, { useState } from 'react';
import { message } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const LoginPage = () => {
    const { login } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            message.success('Signed in.');
            const from = location.state?.from?.pathname || '/dashboard';
            navigate(from);
        } catch (error) {
            console.error('Login error:', error);
            message.error(
                error.response?.data?.message ||
                    'Could not sign in. Check your credentials.'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="fs-auth-card">
            <div className="fs-auth-head">
                <span className="kicker">Sign in</span>
                <h1>Welcome back.</h1>
                <p>Continue where you left off.</p>
            </div>

            <form onSubmit={onSubmit} noValidate>
                <div className="form-field">
                    <label htmlFor="email">Email</label>
                    <input
                        id="email"
                        type="email"
                        autoComplete="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@company.com"
                    />
                </div>

                <div className="form-field">
                    <label htmlFor="password">Password</label>
                    <input
                        id="password"
                        type="password"
                        autoComplete="current-password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••"
                    />
                </div>

                <div className="fs-auth-actions">
                    <button
                        type="submit"
                        className="btn btn-primary btn-block"
                        disabled={loading}
                    >
                        {loading ? 'Signing in…' : (
                            <>Sign in <span className="arrow">→</span></>
                        )}
                    </button>
                </div>
            </form>

            <p className="fs-auth-switch">
                <Link to="/forgot-password">Forgot password?</Link>
            </p>

            <p className="fs-auth-switch">
                No account yet? <Link to="/signup">Create one.</Link>
            </p>
        </section>
    );
};

export default LoginPage;
